import React, { useContext } from 'react'
import { ChangePresentContext, OpsPlanContext } from '../../../SingleEvent'
import { Grid } from '@mui/material'
import PresetsTextField from '../../../../../../components/Forms/PresetsTextField'

const PersonnelSummary = () => {
  const { opsPlan, setOpsPlan } = useContext(OpsPlanContext)
  const { changesPresent, setChangesPresent } = useContext(ChangePresentContext)

  return (
    <Grid item xs={12} lg={6}>
      <PresetsTextField
        value={opsPlan?.personnelSummary}
        label="Personnel Summary"
        multiline
        fullWidth
        minRows={2}
        suggestionPath="opsPlan.personnelSummary"
        suggestionLabel="Personnel summaries from templates"
        InputLabelProps={{
          shrink: !!opsPlan?.personnelSummary,
        }}
        setValue={(newValue) => {
          setOpsPlan((prev) => ({
            ...prev,
            personnelSummary: newValue,
          }))
          !changesPresent && setChangesPresent(true)
        }}
      />
    </Grid>
  )
}

export default React.memo(PersonnelSummary)
